<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Proveedores de Monturas
               <b-button size="sm" @click="nuevoModal()" variant="outline-primary" style="float:right"> Nuevo Proveedor </b-button>
            </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="listado_monturas"
                    dataRoute="monturas"
                    >
                    <template v-slot:modal>
                      <sw-modalprovmontura 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"                     
                        >
                      </sw-modalprovmontura>                  
                      <sw-modalinactive
                        v-if="openModal.modal.modal==='Inactivar'"
                        :nameInactive="nameInactive"
                        @save="saveForm"
                        >
                      </sw-modalinactive>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>  
    <b-modal 
      v-if="openModal.modal.modal==='Nuevo'"
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalprovmontura 
          @save="saveForm"                     
          >
        </sw-modalprovmontura>      
    </b-modal>                  
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalinactive from '@/components/modals/inactive.vue'
import SwModalprovmontura from '@/components/modals/provmontura.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalinactive,
  SwModalprovmontura     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

